import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Conclusioncmore = () => {
  return (
    <div className="conclusion_cmore p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Conclusion</h2>
            <p>
              TekRevol's expertise in delivering tailored solutions shines
              through in this collaboration with the construction industry
              client. CMORE, with its web and mobile applications, along with
              the admin panel, addresses the unique needs of construction
              material stores and builders. It stands as a testament to
              TekRevol's commitment to providing reliable and efficient
              solutions that meet and exceed client expectations. The successful
              implementation of the platform showcases the potential for
              transformative impact through technology in the construction
              commerce sector.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="conc_img">
              <StaticImage
                src="../../../images/case-studies/cmore/conclusion.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1632}
              />
              <StaticImage
                src="../../../images/case-studies/cmore/conc_mob.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1076}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Conclusioncmore;
